import { useApi } from '@fortem-monorepo/react-spa'
import { Feeds } from '@fortem-monorepo/web-sdk'

type Api = ReturnType<typeof useApi>

export const feedsProvidersOptions = (api: Api, params: Feeds.GetProvidersParams) => {
  return {
    queryKey: ['feeds', 'providers', params] as const,
    queryFn: () => api.feeds.getProviders(params),
  }
}

export const feedsNTOptions = (api: Api, params: Feeds.GetNTParams) => {
  return {
    queryKey: ['feeds', 'nt', params] as const,
    queryFn: () => api.feeds.getNT(params),
  }
}

export const feedsDataOptions = (api: Api, params: Feeds.GetTableDataParams) => {
  return {
    queryKey: ['feeds', 'data', params] as const,
    queryFn: () => api.feeds.getTableData(params),
  }
}
